import { Box } from "@mui/material";
import AuthNavBar from "./AuthNavBar";
import GuestNavBar from "./GuestNavBar";
import { DEFAULT_BLUE, DEFAULT_GOLD } from "../constant";
import basmalaNakh from "../../assets/basmala-in-yellow.png";

const Navbar = () => {
  const isUserLoggedIn = false;
  return (
    <Box>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: DEFAULT_BLUE,
          color: "white",
          textAlign: "center",
          zIndex: 2100,
          borderBottom: `3px solid ${DEFAULT_GOLD}`,
          height: "50px !important",
        }}
      >
        <div
          style={{
            height: "25px",
          }}
        >
          <img
            src={basmalaNakh}
            alt="An-Ansaar Logo"
            style={{
              height: "50px",
            }}
          />
        </div>
      </Box>
      {isUserLoggedIn ? <AuthNavBar /> : <GuestNavBar />}
    </Box>
  );
};

export default Navbar;
